import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { RegisterOptions } from 'react-hook-form';

interface FormTextFieldProps extends Omit<TextFieldProps, 'name'> {
  name: string;
  rules?: RegisterOptions;
}

const FormTextField: React.FC<FormTextFieldProps> = ({ name, rules, ...textFieldProps }) => {
  const { register, formState: { errors } } = useFormContext();
  
  const { ref, ...rest } = register(name, rules);
  const fieldError = errors[name];
  
  return (
    <TextField
      {...rest}
      {...textFieldProps}
      inputRef={ref}
      error={!!fieldError}
      helperText={fieldError?.message as string}
    />
  );
};

export default FormTextField;
